import { jsxs as a, jsx as o } from "react/jsx-runtime";
import g from "react";
import { RangoImage as p, ImageAspectRatio as f } from "./Image.js";
import { m as x } from "../chunks/breakpoints.907eaecd.js";
import { styled as i, css as h } from "styled-components";
import { RangoTag as u } from "./Tag.js";
import { RangoButtonMini as b } from "./ButtonMini.js";
import { R as v, H as C } from "../chunks/Heading.2a0f9b41.js";
const t = i(u).withConfig({
  displayName: "Tag",
  componentId: "sc-5vzu58-0"
})([""]), d = i.div.withConfig({
  displayName: "ImageContainer",
  componentId: "sc-5vzu58-1"
})(["position:relative;border-radius:var(--default-border-radius);box-sizing:border-box;overflow:hidden;", "{position:absolute;top:var(--spacing-2_5x);left:var(--spacing-2_5x);}"], t), R = i.div.withConfig({
  displayName: "Content",
  componentId: "sc-5vzu58-2"
})(["display:flex;flex-direction:column;align-items:flex-start;box-sizing:border-box;flex:1 1 auto;gap:var(--spacing-1x);"]), w = i.div.withConfig({
  displayName: "Container",
  componentId: "sc-5vzu58-3"
})(["all:unset;box-sizing:border-box;display:flex;min-height:240px;min-width:240px;width:100%;border-radius:var(--border-radius-md);", " flex-direction:column;", "{flex-basis:181px;margin:0 0 var(--spacing-3x);}"], x.sm(h`
        width: 100%;
    `), d), z = g.forwardRef(({
  tag: n,
  tagProps: s,
  imageProps: m,
  headingProps: r,
  buttonProps: e,
  ...l
}, c) => /* @__PURE__ */ a(w, { ref: c, "data-testid": "rango-card-blog", "data-rango-component": "rango-card-blog", "data-is-rango": !0, ...l, children: [
  /* @__PURE__ */ a(d, { children: [
    n && /* @__PURE__ */ o(t, { ...s, children: n }),
    /* @__PURE__ */ o(p, { ...m, aspectRatio: f["3:4"] })
  ] }),
  /* @__PURE__ */ a(R, { children: [
    /* @__PURE__ */ o(v, { size: C.XS, ...r, children: r.children }),
    /* @__PURE__ */ o(b, { ...e, children: e.children })
  ] })
] }));
z.displayName = "RangoCardBlog";
export {
  z as RangoCardBlog
};
